// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".extraProjectMetadataFields-module__field--OcIi8:not(:last-child){margin-bottom:15px}", "",{"version":3,"sources":["webpack://./jsapp/js/components/modalForms/extraProjectMetadataFields.module.scss"],"names":[],"mappings":"AACE,kEACE,kBAAA","sourcesContent":[".field {\n  &:not(:last-child) {\n    margin-bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": "extraProjectMetadataFields-module__field--OcIi8"
};
export default ___CSS_LOADER_EXPORT___;
